import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Module, Row } from 'components/misc'
import { Form, Title } from 'components/layout'
import { FormattedMessage } from 'react-intl'
import { apiTranslationsManagement } from 'helpers/decorators/api'
import styles from './upload-translation.styl'
import { connect } from 'react-redux'
import {
  UploadTranslationApprovalModal
} from 'components/modals'
import { translationsManagement as translationsManagementApi } from '../../../../redux/modules/api'
import { logError } from 'redux/modules/app'
import { form } from '../../../../helpers/decorators'
import { get } from 'lodash'
import { UploadTranslationResultModal } from '../../../../components/modals'
import { Select } from '../../../../components/fields'
import { validate } from 'models/upload-translation'
import localesByCodeDropdownSelector from '../../../../redux/selectors/locales/localesByCodeDropdownSelector'
import { TRANSLATION_PROJECTS } from '../../../../constants/enums'

@apiTranslationsManagement()
@connect(
  state => ({
    uploadState: state.api.translationsManagement.uploadTranslation,
    uploadResult: state.api.translationsManagement.uploadTranslation.result,
    languages: localesByCodeDropdownSelector(state)
  }), {
    setUploadTranslationResult: translationsManagementApi.setUploadTranslationResult,
    uploadTranslation: translationsManagementApi.uploadTranslation
    }
)
@form({
    form: 'upload-translation-form',
    validate
})
class UploadTranslation extends Component {
  static propTypes = {
    uploadTranslation: PropTypes.func,
    setUploadTranslationResult: PropTypes.func,
    languages: PropTypes.array,
    modal: PropTypes.object,
    uploadState: PropTypes.object,
    uploadResult: PropTypes.object,
    notification: PropTypes.func,
    logError: PropTypes.func,
    onRefreshPage: PropTypes.func,
    handleSubmit: PropTypes.func,
    onSubmit: PropTypes.func,
    loading: PropTypes.bool
  }

  state = {
    language: null,
    project: null
  }

  handleOnApprove = () => {
      const language = get(this.props, 'values.language')
      const project = get(this.props, 'values.project')

      const data = {
        projectCodeList: [project],
        localeList: [language]
      }

      this.props.uploadTranslation(data).then(data => {
      this.props.setUploadTranslationResult(data.body)
      this.props.modal(null)
      this.props.modal('upload-translation-result-modal')
    }).catch(this.handleError)
  }

  handleSubmit(values, event) {
    this.setState({
      language: get(values, 'language'),
      project: get(values, 'project')
    })
    this.props.modal('upload-translation-approval-modal')
    event.preventDefault()
  }

  handleError = err => {
    logError(err)
    this.props.modal(null)
    if (err && err.body) {
      console.debug('error', err.body && err.body.userMessage)
      this.props.notification(err.body.userMessage || 'Error', 'error')
    }
  }

  handleUpdateTranslationFinished = () => {
    this.props.modal(null)
    this.props.onRefreshPage()
  }

  render() {
    const {
      uploadState: { isLoading } = {},
      uploadResult,
      languages,
      handleSubmit
    } = this.props


    const projects = [
      {
        value: TRANSLATION_PROJECTS.backend.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.backend.intlKey} defaultMessage={TRANSLATION_PROJECTS.backend.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.backoffice.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.backoffice.intlKey} defaultMessage={TRANSLATION_PROJECTS.backoffice.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.frontoffice.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.frontoffice.intlKey} defaultMessage={TRANSLATION_PROJECTS.frontoffice.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.userEngagementBackend.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.userEngagementBackend.intlKey} defaultMessage={TRANSLATION_PROJECTS.userEngagementBackend.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.userEngagementFrontend.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.userEngagementFrontend.intlKey} defaultMessage={TRANSLATION_PROJECTS.userEngagementFrontend.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.assessorWebBackend.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.assessorWebBackend.intlKey} defaultMessage={TRANSLATION_PROJECTS.assessorWebBackend.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.assessorWebFrontend.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.assessorWebFrontend.intlKey} defaultMessage={TRANSLATION_PROJECTS.assessorWebFrontend.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.customisableEmails.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.customisableEmails.intlKey} defaultMessage={TRANSLATION_PROJECTS.customisableEmails.defaultMessage} />
      },
      {
        value: TRANSLATION_PROJECTS.documents.id,
        label: <FormattedMessage id={TRANSLATION_PROJECTS.documents.intlKey} defaultMessage={TRANSLATION_PROJECTS.documents.defaultMessage} />
      }
    ]

    return (
      <div className={styles.module_wrapper}>
        <Module verticallyNarrow primary>
          <div className={styles.wrapper}>
            <Row alignItems="center" gutters inner paddingTop>
                <Title h1>
                  <FormattedMessage
                      id="moduleTitle.update_translations"
                      defaultMessage="Update project translations"
                  />
                </Title>
            </Row>
            <Row alignItems="left" gutters inner>
                <FormattedMessage
                  tagName="p"
                  id="translationsManagement.infoLabel"
                  defaultMessage="This page allows to import languages from POEditor. Make sure to update the strings in POEditor project first and tested it on Customer Test environment"
                />
            </Row>
            <Row alignItems="center" gutters inner>
              <Col flex="0 1 600px">
                <Form
                  loading={isLoading}
                  onSubmit={handleSubmit((values, event) => this.handleSubmit(values, event))}
                >
                  <div className="row">
                    <div className="col-xs-10 text--left">
                      <Select
                        name="language"
                        options={languages}
                        hasFormGroup={false}
                        clearable={false}
                        placeholder="Select Language"
                        intlKeyPlaceholder="placeholder.selectLanguage"
                        label="Select Language"
                        intlKey="placeholder.selectLanguage"
                        searchable
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-xs-10 text--left">
                      <Select
                        name="project"
                        options={projects}
                        hasFormGroup={false}
                        clearable={false}
                        placeholder="Select Project"
                        intlKeyPlaceholder="translationsManagment.selectProject"
                        label="Select Project"
                        intlKey="translationsManagment.selectProject"
                        searchable
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-xs-12 text--left">
                      <Button type="submit">
                        <FormattedMessage id="button.upload_translation" defaultMessage="Upload translation" />
                      </Button>
                    </div>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </Module>

        <UploadTranslationApprovalModal
              modalId="upload-translation-approval-modal"
              isLoading={isLoading}
              onApprove={this.handleOnApprove}
              language={this.state.language}
              project={this.state.project}
        />

        <UploadTranslationResultModal
            modalId="upload-translation-result-modal"
            result={uploadResult.resultMap}
            onConfirmed={this.handleUpdateTranslationFinished}
        />

      </div>
    )
  }
}

export default UploadTranslation
